import PoweredBy from '../components/links/PoweredBy'
import React, { useState, useEffect } from "react"

export default function() {

  const textColor = window._textColor
  const link = window._link

  return(
    <div className="d-flex min-vh-100 align-items-center">

      <div className="w-100 pt-4 pb-0 pb-md-5" style={{ minHeight: '600px' }}>
        <div className="d-inline-block w-100 h-100">
          <div className="row">
            <div className="col-12 col-md-6">
              <div className="d-flex justify-content-end h-100 px-4 px-md-0 pb-4 pb-md-0" style={{ color: textColor }}>
                
                <div className="container row pe-0 pe-md-5 justify-content-end">

                  <div className="col-5 pt-4 d-flex flex-column payment-link-column left h-100">
                    
                    <h6 className="pt-3 pt-md-1 pb-1 fs-6 mb-0 opacity-50" style={{ color: textColor }}>
                      Loading...
                    </h6>

                    <div className="flex-grow-1 pt-2" style={{ minHeight: '20vh' }}>
                      <div className="rounded-1 skeleton" style={{ width: '240px', height: '40px' }}/>
                    </div>

                    <div className="align-self-end w-100 d-none d-md-block pt-6">
                      <PoweredBy link={ link } textColor={ textColor }/>
                    </div>

                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 ps-0 ps-md-5 pt-md-4">
              
              <div className="container row pe-0 pe-md-5">
                
                <div className="col-5 payment-link-column right px-4 px-md-0 bg-grey pb-0 pt-4 pt-md-0">

                  <h2 className="h5 mb-2 pt-4">Pay with crypto</h2>

                  <div className="flex-grow-1 pt-3" style={{ minHeight: '39vh' }}>
                    <div className="rounded-2 skeleton" style={{ width: '100%', height: '50px' }}/>
                  </div>

                  <div className="align-self-end w-100 d-block d-md-none pt-5 pb-3 text-center">
                    <PoweredBy link={ link } textColor={ '#430137' }/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>    
  )
}
